// Alternative for Object.entries() that narrows down the key type.
export const entries = <K extends string, V>(obj: { [_ in K]?: V }): [K, V][] => {
    return Object.entries(obj) as [K, V][]
}
